import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { ROUTE_TITLES } from "./routes";

const PageTitle = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const routeKey = Object.keys(ROUTE_TITLES).find(
      (route) => pathname === route || pathname.endsWith(route),
    );
    const title = routeKey ? ROUTE_TITLES[routeKey] : undefined;
    if (title) document.title = title;
  }, [pathname]);

  return null;
};

export default PageTitle;
